export default __webpack_public_path__ + "static/rings-d30b998cb283ed48a7d515f924895843.png";